export const ClearPhone = (phone) => {
    if (!phone || typeof phone !== "string") {
        return ""; // Retorna una cadena vacía si el valor no es válido
    }

    let clear = phone.replace(/[\s-]/g, ""); // Remove spaces and dashes
    // Check if the phone number starts with "+507" or "507"
    if (clear.startsWith("+507")) {
        clear = clear.slice(4); // Remove "+507"
    } else if (clear.startsWith("507")) {
        clear = clear.slice(3); // Remove "507"
    }
    return clear; // Return the cleaned phone number
}